import React from 'react';
import { fmt } from '../utils/calcul';
import { Session } from '../types';
import './HistoriqueSessions.css';

interface Props {
  sessions: Session[];
  sessionActive: Session | null;
  onSelect: (s: Session) => void;
  onSupprimer: (id: number) => void;
  onExportPDF: () => void;
}

export default function HistoriqueSessions({ sessions, sessionActive, onSelect, onSupprimer }: Props) {
  return (
    <div className="hist-card">
      <div className="hist-header">
        <h3 className="hist-title">
          Historique
          <span className="hist-count">{sessions.length}</span>
        </h3>
      </div>
      <div className="hist-list">
        {sessions.map(s => {
          const isActive = sessionActive && sessionActive.id === s.id;
          return (
            <div
              key={s.id}
              className={`hist-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelect(s)}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && onSelect(s)}
              aria-pressed={!!isActive}
            >
              <div className="hist-item-main">
                <span className="hist-montant">{fmt(s.montant)} <small>FCFA</small></span>
                <span className="hist-meta">
                  {s.parts.length} parts · ×{s.base} · {s.date}
                </span>
              </div>
              <button
                className="hist-del"
                onClick={e => { e.stopPropagation(); onSupprimer(s.id); }}
                title="Supprimer"
                aria-label="Supprimer cette répartition"
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
